import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import make_translations from "@pdfking/workflow/utils/make_translations"
import proxy from "@pdfking/workflow/utils/proxy"
import user from "../state/user"

export const Username = CreateRenderFunction({
  computed: {
    ...proxy(user(), ["name"] as const),
    translations: () => make_translations("actions"),
  },
  render() {
    return (
      <span>{(this.name || this.translations.actions.GUEST) as string}</span>
    )
  },
})
